/**
 * `/s/:token` — the page a share link opens (PLAN-LAUNCH D1).
 *
 * Short and outside `/recipes` on purpose: this URL gets pasted into forum
 * posts and group chats, and it addresses a *token*, not a document id in
 * anyone's workspace. The root layout renders this route without the app shell
 * (see `__root.tsx`), because the visitor has no sidebar, no workspace and no
 * reason to be offered one.
 *
 * One token may name a recipe — live, or a batch's as brewed — or a blending
 * session (PLAN-SHARE-BLEND §3). Which it is comes back with the answer rather
 * than being readable off the URL, so {@link SharedTokenPage} makes that switch
 * on one read and this route stays what it has always been: the params and the
 * way back into the app.
 *
 * The one thing this file adds to the page is that way *into* the app: after a
 * gallery clone (PLAN-GALLERY G3) the visitor has a recipe of their own, and
 * this route knows the router that can open it. Navigating rather than reloading
 * matters — the workspace persists on a debounce, so a fresh document moments
 * after a clone can beat the write to IndexedDB and boot without it.
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SharedTokenPage } from '@/components/share/shared-recipe';

export const Route = createFileRoute('/s/$token')({
  component: SharedTokenRoute,
});

function SharedTokenRoute() {
  const { token } = Route.useParams();
  const navigate = useNavigate();
  return (
    <SharedTokenPage
      token={token}
      onOpenRecipe={(recipeId) => {
        void navigate({ to: '/recipes/$recipeId', params: { recipeId } });
      }}
    />
  );
}
